// extracted by mini-css-extract-plugin
export default {"workcontainer":"OurWork_workcontainer__zbjLL","sha":"OurWork_sha__sg7fu"};